/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PersonalAssetMetaDataDto,
    PersonalAssetMetaDataDtoFromJSON,
    PersonalAssetMetaDataDtoFromJSONTyped,
    PersonalAssetMetaDataDtoToJSON,
} from './PersonalAssetMetaDataDto';
import {
    PersonalAssetTypeEnum,
    PersonalAssetTypeEnumFromJSON,
    PersonalAssetTypeEnumFromJSONTyped,
    PersonalAssetTypeEnumToJSON,
} from './PersonalAssetTypeEnum';

/**
 * 
 * @export
 * @interface CreatePersonalAssetDto
 */
export interface CreatePersonalAssetDto {
    /**
     * 
     * @type {PersonalAssetTypeEnum}
     * @memberof CreatePersonalAssetDto
     */
    type: PersonalAssetTypeEnum | null;
    /**
     * 
     * @type {PersonalAssetMetaDataDto}
     * @memberof CreatePersonalAssetDto
     */
    metaData?: PersonalAssetMetaDataDto;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalAssetDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalAssetDto
     */
    iconName: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalAssetDto
     */
    colorName: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalAssetDto
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonalAssetDto
     */
    portfolioId: string;
}

export function CreatePersonalAssetDtoFromJSON(json: any): CreatePersonalAssetDto {
    return CreatePersonalAssetDtoFromJSONTyped(json, false);
}

export function CreatePersonalAssetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePersonalAssetDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PersonalAssetTypeEnumFromJSON(json['type']),
        'metaData': !exists(json, 'metaData') ? undefined : PersonalAssetMetaDataDtoFromJSON(json['metaData']),
        'name': json['name'],
        'iconName': json['iconName'],
        'colorName': json['colorName'],
        'currencyCode': json['currencyCode'],
        'portfolioId': json['portfolioId'],
    };
}

export function CreatePersonalAssetDtoToJSON(value?: CreatePersonalAssetDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PersonalAssetTypeEnumToJSON(value.type),
        'metaData': PersonalAssetMetaDataDtoToJSON(value.metaData),
        'name': value.name,
        'iconName': value.iconName,
        'colorName': value.colorName,
        'currencyCode': value.currencyCode,
        'portfolioId': value.portfolioId,
    };
}

